import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.setupConfirmations();
  }

  setupConfirmations() {
    // Find all elements with data-confirm attribute in the controller scope
    const confirmElements = document.querySelectorAll("[data-confirm]");

    confirmElements.forEach((element) => {
      // Remove the default Rails UJS handler by cloning the node
      const newElement = element.cloneNode(true);
      element.parentNode.replaceChild(newElement, element);

      // Add our custom event listener
      newElement.addEventListener("click", (event) => {
        const message = newElement.getAttribute("data-confirm");
        if (message && !confirm(message)) {
          event.preventDefault();
        }
      });
    });
  }
}
